import { useContext } from "react"
import { Routes, Route } from "react-router-dom"
import { LogsInitContext } from "../Providers/LogsInitComponentesContext/LogsInitComponentesContext"
import LoginPage from "../Pages/LoginPage/LoginPage"
import ConfiguracoesPage from "../Pages/ConfiguracoesPage/ConfiguracoesPage"
import MonitoramentoPage from "../Pages/MonitoramentoPage/MonitoramentoPage"
import GestaoEventos from "../Pages/GestaoEventos/GestaoEventos"
import Relatorios from "../Pages/RelatoriosPage/RelatoriosPage"

const RoutesOne = () => {
    const { LogInit } = useContext(LogsInitContext)
    LogInit('RoutesOne', 'componente')

    return (
        <Routes>
            <Route path="/wsOnePortaria/Plus" element={<MonitoramentoPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/configuracoes" element={<ConfiguracoesPage />} />
            <Route path="/gestaoEventos" element={<GestaoEventos />} />
            <Route path="/relatorios" element={<Relatorios />} />

            {/* <Route path="/" element={<RequireAuth><AreaCliente /></RequireAuth>} /> */}
        </Routes>
    )
}

export default RoutesOne
